import { ChevronDownIcon, SettingsIcon } from 'lucide-react';

import React from 'react';

import { useTranslation } from '@splitfiesta/i18n';

interface ProgressiveDisclosureToggleProps {
  isExpanded: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

export function ProgressiveDisclosureToggle({
  isExpanded,
  onToggle,
  disabled = false,
}: ProgressiveDisclosureToggleProps) {
  const { t } = useTranslation('expenses');

  return (
    <div className="relative">
      {/* Divider line */}
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200 dark:border-gray-700" />
      </div>

      {/* Toggle button */}
      <div className="relative flex justify-center">
        <button
          type="button"
          onClick={onToggle}
          disabled={disabled}
          aria-expanded={isExpanded}
          aria-label={
            isExpanded
              ? t('actions.showFewerOptions')
              : t('actions.showMoreOptions')
          }
          className={`
            px-4 py-2 bg-white dark:bg-gray-800 
            border border-gray-200 dark:border-gray-700 
            rounded-full flex items-center space-x-2
            text-sm font-medium text-gray-700 dark:text-gray-300
            hover:bg-gray-50 dark:hover:bg-gray-700
            hover:text-orange-600 dark:hover:text-orange-400
            hover:border-orange-300 dark:hover:border-orange-600
            focus:outline-hidden focus:ring-2 focus:ring-orange-500 focus:ring-offset-2
            transition-all duration-200
            ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          `}
        >
          <SettingsIcon className="w-4 h-4" />
          <span>
            {isExpanded
              ? t('actions.showFewerOptions')
              : t('actions.showMoreOptions')}
          </span>
          <ChevronDownIcon
            className={`w-4 h-4 transition-transform duration-200 ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </button>
      </div>
    </div>
  );
}

export default ProgressiveDisclosureToggle;
